<template>
    <div style="margin: 20px auto 0px auto ; background-color:white; width: 1160px; min-height: 600px; border-radius: 10px; border:2px solid lightgrey ;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <div style="padding: 20px; font-size: 26px;">{{ problem.pbid }} -- {{ problem.name }}</div>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1" style="width: 140px; text-align: center; font-size: 15px;">
                <i class="el-icon-edit"></i>题目详情
            </el-menu-item>
            <el-menu-item index="2" style="width: 140px; text-align: center; font-size: 15px;">
                <i class="el-icon-date"></i>提交记录
            </el-menu-item>
            <el-menu-item index="3" style="width: 140px; text-align: center; font-size: 15px;">
                <i class="el-icon-date"></i>题解
            </el-menu-item>
            <el-menu-item index="4" style="width: 140px; text-align: center; font-size: 15px;">
                <i class="el-icon-date"></i>题解视频
            </el-menu-item>
        </el-menu>
        <router-view style="margin-top: 20px;"></router-view>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Url from '@/constant/Url'

    export default {
        name:'Problem',
        data() {
            return {
                activeIndex:'',

                problem:{},
            }
        },
        created() {
            const params = this.$route.params
            const vue = this

            $.ajax({
                url:'https://app6132.acapp.acwing.com.cn/api/question/get/one/',
                type:'post',
                data: {
                    id: params.id,
                },
                success(resp) {
                    if (resp.error_message === "success") {
                        vue.problem = JSON.parse(resp.problem);
                    } else {
                        console.log("题目信息获取失败了, error_message == >", resp.error_message)
                    }
                },
                error(resp) {
                    console.log("题目信息获取彻底失败了, resp == >", resp)
                }
            })
        },
        mounted() {
            if (this.$route.path === `/Problem/Content/${this.$route.params.id}`) this.activeIndex = "1"
            else if (this.$route.path === `/Problem/Record/${this.$route.params.id}`) this.activeIndex = "2"
            else if (this.$route.path === `/Problem/Solve/${this.$route.params.id}`) this.activeIndex = "3"
            else if (this.$route.path === `/Problem/Vedio/${this.$route.params.id}`) this.activeIndex = "4"
        },
        methods: {
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
                if (key === '2') {
                    if (this.$route.path !== `/Problem/Record/${this.$route.params.id}`)
                    this.$router.push(`/Problem/Record/${this.$route.params.id}`)
                } 
                else if (key === '1'){
                    if (this.$route.path !== `/Problem/Content/${this.$route.params.id}`)
                    this.$router.push(`/Problem/Content/${this.$route.params.id}`)
                }
                else if (key === '3'){
                    if (this.$route.path !== `/Problem/Solve/${this.$route.params.id}`)
                    this.$router.push(`/Problem/Solve/${this.$route.params.id}`)
                }
                else if (key === '4'){
                    if (this.$route.path !== `/Problem/Vedio/${this.$route.params.id}`)
                    this.$router.push(`/Problem/Vedio/${this.$route.params.id}`)
                }
            },
        }
    }
</script>

<style>

</style>